<template>
  <div class="d-flex">
    <px-select-enum dense
                    v-model="moeda"
                    :items="opcoesMoedasFiltered"
                    :error="$v.moeda.$error"
                    @blur="$v.moeda.$touch()"
                    class="rounded-tag-small required"
                    label="Moeda"/>
    <v-text-field
      dense
      outlined
      hide-details
      maxlength="250"
      label="Código interno"
      class="rounded-tag-small ml-3"
      v-model="codigoInterno"
    />
    <v-btn color="primary"
           class="rounded-tag-small normal-btn-text elevation-0 ml-3"
           :loading="loading"
           @click="onAddMoeda">
      <v-icon left>mdi-plus</v-icon>
      Moeda
    </v-btn>
  </div>
</template>

<script>
import { Moeda } from 'px-business-components';
import { required } from 'vuelidate/lib/validators';
import validationMixin from '@/mixins/validation-mixin';
import ConfiguracaoMoedaService from '@/modules/configuracoes-moedas/configuracao-moeda.service';

export default {
  mixins: [validationMixin],
  props: {
    moedas: Array,
  },
  data() {
    return {
      loading: false,
      moeda: null,
      codigoInterno: null,
      opcoesMoedas: Moeda.values,
    };
  },
  computed: {
    opcoesMoedasFiltered() {
      return this.opcoesMoedas
        .filter(moeda => !this.moedas.map(m => m.moeda)
          .includes(moeda.key));
    },
  },
  methods: {
    onAddMoeda() {
      if (this.validateForm()) {
        return;
      }
      this.loading = true;
      ConfiguracaoMoedaService.createConfiguracaoMoeda({
        moeda: this.moeda,
        codigoInterno: this.codigoInterno,
      })
        .then(() => {
          this.$emit('change');
          this.moeda = null;
          this.codigoInterno = null;
          this.$v.$reset();
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
  validations: {
    moeda: {
      required,
    },
  },
};
</script>
